import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ChatIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.594717 2.86976C0.000171661 3.99406 0.000171661 5.46584 0.000171661 8.40941V9.65421C0.000171661 11.4299 0.000171661 12.3176 0.220535 13.0418C0.743299 14.7596 2.13726 16.1028 3.91992 16.6065C4.67155 16.8188 5.59283 16.8188 7.43559 16.8188H8.03428L8.1053 16.8189C9.21825 16.8258 10.3025 17.1606 11.2123 17.7783L11.2701 17.8181L14.1182 19.7783C15.0945 20.4502 16.3775 19.4798 15.9319 18.4064C15.6163 17.646 16.1974 16.8188 17.0474 16.8188H17.7038C19.9762 16.8188 21.8184 15.0438 21.8184 12.8541V8.40941C21.8184 5.46584 21.8184 3.99406 21.2238 2.86976C20.7009 1.88081 19.8665 1.07675 18.8401 0.572859C17.6733 6.2655e-08 16.1459 0 13.0911 0H8.72745C5.67257 0 4.14519 6.2655e-08 2.97835 0.572859C1.95203 1.07675 1.11759 1.88081 0.594717 2.86976ZM15.2729 5.51867C15.7248 5.51867 16.0911 5.87165 16.0911 6.30706C16.0911 6.74246 15.7248 7.09544 15.2729 7.09544H10.9093C10.4574 7.09544 10.0911 6.74246 10.0911 6.30706C10.0911 5.87165 10.4574 5.51867 10.9093 5.51867H15.2729ZM15.2729 9.72338C15.7248 9.72338 16.0911 10.0764 16.0911 10.5118C16.0911 10.9472 15.7248 11.3001 15.2729 11.3001H6.54563C6.09377 11.3001 5.72745 10.9472 5.72745 10.5118C5.72745 10.0764 6.09377 9.72338 6.54563 9.72338H15.2729Z"
        fill="currentColor"
      />
    </svg>
  )
})

ChatIcon.displayName = 'ChatIcon'
